import { IHlaAllele } from "./hla-allele";

export interface IHlaEplet {
    id: number;
    name: string;
    hlaGeneGroup: number;
    polymorphicResidue: string;
    hasAntibodyReactivity: boolean;
    notes: string;
    alleleEplets: IHlaAllele[];
}